export default __webpack_public_path__ + "5c69edd35affef56e31e0b9e8b55f225.svg";